"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transaction = void 0;
// ------ Start of Schemer Auto Generated Code Block (Transaction Typescript Class) ------ //
class Transaction {
}
exports.Transaction = Transaction;
// ------ End   of Schemer Auto Generated Code Block (Transaction Typescript Class) ------ //
//# sourceMappingURL=transaction.js.map